import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import '../Dashboard.css';

const BreakingResultsMain = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="dashboard-layout">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className="dashboard-content">
        <div className="dashboard-header">
          <button className="menu-toggle" onClick={toggleSidebar}>
            ☰
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap' }}>
            <button 
              onClick={() => navigate('/cubes')}
              style={{
                background: 'linear-gradient(135deg, #64748b 0%, #475569 100%)',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '10px',
                cursor: 'pointer',
                fontSize: '15px',
                fontWeight: '700',
                transition: 'all 0.3s',
                boxShadow: '0 4px 12px rgba(100, 116, 139, 0.3)'
              }}
            >
              ← رجوع للمكعبات
            </button>
            <h1 style={{ margin: 0 }}>📊 نتائج التكسير</h1>
          </div>
        </div>

        <div className="dashboard-main">
          <style>{`
            .results-main-container {
              padding: 40px 20px;
              max-width: 1200px;
              margin: 0 auto;
            }

            .cards-grid {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
              gap: 30px;
              margin-top: 30px;
            }

            .main-card {
              background: white;
              border-radius: 20px;
              padding: 40px;
              box-shadow: 0 8px 30px rgba(0,0,0,0.12);
              transition: all 0.3s;
              cursor: pointer;
              border: 3px solid transparent;
              text-align: center;
            }

            .main-card:hover {
              transform: translateY(-10px);
              box-shadow: 0 15px 40px rgba(0,0,0,0.2);
            }

            .main-card.add-card {
              border-color: #16a34a;
            }

            .main-card.add-card:hover {
              border-color: #22c55e;
              background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
            }

            .main-card.view-card {
              border-color: #3b82f6;
            }

            .main-card.view-card:hover {
              border-color: #60a5fa;
              background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
            }

            .card-icon {
              font-size: 80px;
              margin-bottom: 20px;
              display: block;
            }

            .card-title {
              font-size: 28px;
              font-weight: 800;
              margin: 0 0 15px 0;
              color: #1e293b;
            }

            .card-description {
              font-size: 16px;
              color: #64748b;
              margin: 0;
              line-height: 1.6;
            }

            @media (max-width: 768px) {
              .results-main-container {
                padding: 20px 15px;
              }

              .cards-grid {
                grid-template-columns: 1fr;
                gap: 20px;
              }

              .main-card {
                padding: 30px;
              }

              .card-icon {
                font-size: 60px;
              }

              .card-title {
                font-size: 22px;
              }

              .card-description {
                font-size: 14px;
              }
            }
          `}</style>

          <div className="results-main-container">
            <div className="cards-grid">
              {/* كارت إضافة نتائج التكسير */}
              <div 
                className="main-card add-card"
                onClick={() => navigate('/cubes/results/add')}
              >
                <span className="card-icon">➕</span>
                <h2 className="card-title">إضافة نتائج التكسير</h2>
                <p className="card-description">
                  جلب المكعبات من تكسير اليوم وإدخال نتائج الاختبارات
                </p>
              </div>

              {/* كارت عرض النتائج */}
              <div 
                className="main-card view-card"
                onClick={() => navigate('/cubes/results/view')}
              >
                <span className="card-icon">📅</span>
                <h2 className="card-title">عرض النتائج</h2>
                <p className="card-description">
                  عرض نتائج التكسير حسب التاريخ والاطلاع على الأوراق الرسمية
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreakingResultsMain;
